module.exports = __webpack_public_path__ + "static/media/12-pedro-saboya.cc8d2949.webp";